import React, { useEffect, useRef, useState } from "react";
import { IProps } from "./types";
import uploadIcon from "../../assets/img/upload.svg";
import FetchUpload from "../../utils/api/upload";
import * as Notification from '../../components/Notification';
import { connect } from "react-redux";
import { REDUCER_TYPE } from "../../modules/Reducer";
import logo from "../../assets/img/logo.svg";
import { useTranslation } from "react-i18next";
import "../../assets/scss/upload.scss";

const Uploud = (props: IProps & any) => {
  const [progress, setProgress] = useState(0);
  const [isUpload, setIsUpload] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();

  const handleUpload = () => {
    fileInputRef.current?.click();
  };

  const upload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    const data = new FormData();
    data.append('file', file);

    const params = new URLSearchParams(window.location.search);
    const activeChatId = params.get('chatId');
    const receipientId = activeChatId && activeChatId !== 'group' ? activeChatId : null;

    FetchUpload(
      String(props.jwtToken),
      props.room,
      props.authUser,
      data,
      (loaded: number, total: number) => {
        const percent = Math.round((loaded * 100) / total);
        setProgress(percent);
        setIsUpload(true);

        if (percent === 100) {
          setTimeout(() => {
            setIsUpload(false);
            setProgress(0);
            if (fileInputRef.current) fileInputRef.current.value = '';
          }, 3000);
        }
      },
      (error: any) => {
        Notification.error(error.message);
      },
      receipientId
    );
  };

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.get('upload') === '1') {
        const btn = document.getElementById('uploadBtnHandled') as HTMLElement | null;
        if (btn) {
          btn.click();
        } else {
          handleUpload();
        }
      }
    } catch (e) {
      // no-op
    }
  }, []);

  return (
    <div className="attachments" style={(props.isActiveTab ? {} : { display: "none" })}>
      <input type="file" ref={fileInputRef} className="upload-file-input-hidden" onChange={upload} />
      <div className="attachments-container">
        <div className="upload-logo-wrapper">
          <img className="logo" src={logo} alt=""/>
        </div>
        <p className="">{t('upload:title')}</p>
        <div className="attachments-list-container text-center">
          {!isUpload && (
            <div id="uploadBtn" className="upload-btn-row" onClick={handleUpload} style={{cursor: "pointer"}}>
              <div className="upload-btn-box">
                {t('upload:addAttachment')}
                <img
                  src={uploadIcon}
                  alt=""
                  className="upload-btn-icon"
                  id={'uploadBtnHandled'}
                />
              </div>
            </div>
          )}
          {isUpload && (
            <div className={`messages-bar-progress ${progress === 100 ? 'is-complete' : 'is-active'}`}>
              <p>{progress}%</p>
            </div>
          )}
          <div className="upload-hint">
            {t('upload:maxFileSize')}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: REDUCER_TYPE) => state;

export default connect(mapStateToProps)(Uploud);
